<template>
    <div >
        <label>{{ $t('message_template.order_setting') }}</label>

        <p-button block size="sm" outline @click="decreaseOrder" v-b-tooltip :title="$t('message_template.decrease')">
            <b-icon icon="arrow-up" scale="1.0"></b-icon>
        </p-button>

        <p-button block size="sm" outline @click="increaseOrder" v-b-tooltip :title="$t('message_template.increase')">
            <b-icon icon="arrow-down" scale="1.0"></b-icon>
        </p-button>

    </div>
</template>

<script>

import messagetemplates from '@/store/dispatching/messagetemplates'

export default {
    props: {
        item: {        
            default: function () {
                return {
                        "id": null,
                        "order":null,
                        "message": null
                }
            }        
         },
        action: { default: "edit" }
    },
    data: function() {
        return {
            updateItem: null
        }
    },
    methods: {
        updateOrder() {
           this.$store.dispatch('messagetemplates/setDriverMessageOrder', this.updateItem).then(
            (response) => {
                this.ok = response.data.errorCode == 0
                this.error = !this.ok
                this.loading = false
            },
            ()=>{
                this.error = true;
            });

        },
        increaseOrder() {
            this.updateItem.order++;
            this.updateItem.order++;
            //this.$emit('newOrder', this.item);
            this.updateOrder();
        },
        decreaseOrder() {
            this.updateItem.order--;
           // this.$emit('newOrder', this.item);  
            this.updateOrder();      
        }
    },
    created() {
        if (!this.$store.state.messagetemplates) {
            this.$store.registerModule("messagetemplates" , messagetemplates);
        }
        this.ok = this.error = this.loading = false;  
        this.updateItem = JSON.parse(JSON.stringify(this.item));
    },
    watch: {
        item() {
            this.updateItem = JSON.parse(JSON.stringify(this.item));
        }
    }
}

</script>
